var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_12540)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#B5D8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 98.25C20.25 93.375 27.375 89.5325 35.25 86.7225C43.125 83.9125 51.375 82.505 60 82.5C68.625 82.495 76.875 83.9025 84.75 86.7225C92.625 89.5425 99.75 93.385 106.125 98.25C110.5 93.125 113.908 87.3125 116.348 80.8125C118.788 74.3125 120.005 67.375 120 60C120 43.375 114.158 29.2175 102.473 17.5275C90.7875 5.8375 76.63 -0.00500011 60 0C43.37 0.00500011 29.2125 5.85 17.5275 17.535C5.84251 29.22 9.53674e-06 43.375 9.53674e-06 60C9.53674e-06 67.375 1.22001 74.3125 3.66001 80.8125C6.10001 87.3125 9.50501 93.125 13.875 98.25ZM60 67.5C52.625 67.5 46.405 64.97 41.34 59.91C36.275 54.85 33.745 48.63 33.75 41.25C33.755 33.87 36.2875 27.65 41.3475 22.59C46.4075 17.53 52.625 15 60 15C67.375 15 73.595 17.5325 78.66 22.5975C83.725 27.6625 86.255 33.88 86.25 41.25C86.245 48.62 83.715 54.84 78.66 59.91C73.605 64.98 67.385 67.51 60 67.5ZM60 135C49.625 135 39.875 133.03 30.75 129.09C21.625 125.15 13.6875 119.808 6.93751 113.062C0.187511 106.318 -5.15499 98.38 -9.08999 89.25C-13.025 80.12 -14.995 70.37 -15 60C-15.005 49.63 -13.035 39.88 -9.08999 30.75C-5.14499 21.62 0.197512 13.6825 6.93751 6.9375C13.6775 0.192501 21.615 -5.15 30.75 -9.09C39.885 -13.03 49.635 -15 60 -15C70.365 -15 80.115 -13.03 89.25 -9.09C98.385 -5.15 106.323 0.192501 113.063 6.9375C119.803 13.6825 125.148 21.62 129.098 30.75C133.048 39.88 135.015 49.63 135 60C134.985 70.37 133.015 80.12 129.09 89.25C125.165 98.38 119.823 106.318 113.063 113.062C106.303 119.808 98.365 125.152 89.25 129.097C80.135 133.042 70.385 135.01 60 135Z",
    fill: "#DCECFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_12540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankAvatar);
export default __webpack_public_path__ + "static/media/BlankAvatar.6add70a637c776d171c6ffed71531444.svg";
export { ForwardRef as ReactComponent };